<div class="app-dropdown mat-elevation-z4" *ngIf="isOpen">
  <ng-content></ng-content>
</div>
